export const SETUP_INTENT_STRIPE_REQUEST = 'SETUP_INTENT_STRIPE_REQUEST';
export const CREATE_CART_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST =
  'CREATE_CART_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST';
